import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import client from "../lib/api";
import { Crest, SectionTitle, Loading, Card } from "../components/common";

export default function ClubsPage() {
  const [clubs, setClubs] = useState(null);
  useEffect(() => { client.get("/clubs").then((r) => setClubs(r.data)).catch(() => setClubs([])); }, []);
  if (!clubs) return <Loading />;
  return (
    <div data-testid="clubs-page">
      <SectionTitle kicker="18 clubs · 2026">Clubs</SectionTitle>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
        {clubs.map((c) => (
          <Link to={`/clubs/${c.slug}`} key={c.slug} data-testid={`club-card-${c.slug}`}>
            <Card className="p-5 flex flex-col items-center text-center gap-3 hover:-translate-y-1 transition-transform">
              <Crest slug={c.slug} name={c.name} size={56} url={c.badge} />
              <div>
                <div className="font-head font-bold text-green leading-tight">{c.name}</div>
                <div className="text-xs text-ink/50 mt-0.5">{c.city}</div>
              </div>
            </Card>
          </Link>
        ))}
      </div>
    </div>
  );
}
